import 'antd/dist/antd.css';

import { useLocation } from 'react-router-dom';
import { createContext, useEffect, useState } from 'react';

export const RouterContext = createContext({ to: '', from: '' });

interface IRouterContextApp {
  children: JSX.Element;
}

const RouterContextApp = ({ children }: IRouterContextApp) => {
  const location = useLocation();
  const [route, setRoute] = useState({
    to: location.pathname,
    from: location.pathname,
  });

  useEffect(() => {
    setRoute(prev => ({ to: location.pathname, from: prev.to }));
  }, [location]);

  return (
    <RouterContext.Provider value={route}>{children}</RouterContext.Provider>
  );
};

export default RouterContextApp;
